import {
  getCompanyByName,
  normalizeCityName,
} from "@/common/helpers/company.helpers";
import { useCompanyStore } from "@/common/states/store/Company";

export const useLeadsByCity = (
  leadsByTime: Record<string, number> | undefined
) => {
  const allCompanies = useCompanyStore((state) => state.availableCompanies);
  const activeCompanies = allCompanies.filter((c) => c.active);
  const cityMap = new Map(
    activeCompanies.map((c) => [normalizeCityName(c.name), c.sigla])
  );

  const totalLeadsByCity = Object.values(leadsByTime || {}).reduce(
    (acc, cityEntries) => {
      Object.entries(cityEntries || {}).forEach(([cityName, value]) => {
        const normalizedCityName = normalizeCityName(cityName);
        const matchedCompany = getCompanyByName(cityName);
        const sigla = matchedCompany?.sigla || cityMap.get(normalizedCityName);

        if (!sigla) {
          console
          return;
        }

        acc[sigla] = (acc[sigla] || 0) + value;
      });
      return acc;
    },
    {} as Record<string, number>
  );

  const allLeadsByCityEntries = activeCompanies
    .map((c) => [c.name, totalLeadsByCity[c.sigla] || 0] as [string, number])
    .sort(([, a], [, b]) => b - a);

  return { allLeadsByCityEntries };
};
